module.exports = function(dashboard) {
	"use strict";
	dashboard
  	.controller('dashboardController', dashboardController);
	dashboardController.$inject = ["getConfigData","keyPressOnlyNumberAndDot","activeClass","config","getIspTitle","putDataService","$scope","$rootScope","getDataService","jQuery","refreshtokenService","alertService","serverError","authtokenService","postDataService","$interval", '$compile','$timeout', 'offlineError'];
	
  function dashboardController(getConfigData,keyPressOnlyNumberAndDot,activeClass,config,getIspTitle,putDataService,$scope,$rootScope,getDataService,jQuery,refreshtokenService,alertService, serverError, authtokenService,postDataService,$interval, $compile,$timeout, offlineError) {
    var vmd = this;
    // vmd.realtime = [];
    // vmd.loadAnalytics = {};
    // vmd.ispLabels = [];
    // vmd.getIspTitle = getIspTitle;
    getConfigData.getData('dashboard');
    vmd.config = angular.copy(config);
    $scope.$watch(function() {
			return config
		}, function(newValue, oldValue) {
			if(newValue !== oldValue) {
				vmd.config = angular.copy(config);
			}
		},true);
    // vmd.chartOptions = {};
    vmd.keyPressOnlyNumberAndDot = keyPressOnlyNumberAndDot;
    // var date_start = null;
    // var date_end = null;  
    // $scope.ranges = {
    //   'Today': [moment().startOf('day'), moment().endOf('day')]
    // };
    // function isValidBlackTheme(config) {
    //   // Check if config exists and is an object
    //   if (!config || typeof config !== 'object') {
    //       return false;
    //   }
  
    //   // Check if black_theme exists and is an object
    //   if (!config.black_theme || typeof config.black_theme !== 'object') {
    //       return false;
    //   }
  
    //   // Check if date_start exists and is valid number
    //   if (typeof config.black_theme.date_start !== 'number' || 
    //       config.black_theme.date_start <= 0) {
    //       return false;
    //   }
  
    //   // Check if date_end exists and is valid number
    //   if (typeof config.black_theme.date_end !== 'number' || 
    //       config.black_theme.date_end <= 0) {
    //       return false;
    //   }
  
    //   // Check if date_start is before date_end
    //   if (config.black_theme.date_start > config.black_theme.date_end) {
    //       return false;
    //   }
  
    //   // Validate moment dates
    //   try {
    //     const startMoment = moment(config.black_theme.date_start * 1000);
    //     const endMoment = moment(config.black_theme.date_end * 1000);

    //     // Check if moments are valid
    //     if (!startMoment.isValid()) {
    //         return false;
    //     }

    //     if (!endMoment.isValid()) {
    //         return false;
    //     }

    //   } catch (error) {
    //     return false;
    //   }
  
    //   return true;
    // }
    // if (isValidBlackTheme(vmd.config)) {
    //   vmd.blackTheme = true;
    //   date_start = vmd.config.black_theme.date_start;
    //   date_end = vmd.config.black_theme.date_end;
    //   $scope.myDateRange = {
    //     startDate: moment(date_start * 1000),
    //     endDate: moment(date_end * 1000)
    //   };
    // }
    if($rootScope.role_id == 'superadmin') {
      vmd.superPermisions = true;
    }
    if($rootScope.role_id == 'superadmin' || $rootScope.role_id == 'administrator') {
      vmd.adminPermisions = true;
    }
    vmd.scriptVersionUpdate = function() {
      var validate = true;
      if(vmd.config.www_script_version) {
        vmd.www_script_versionRequired = false;
      } else {
        validate = false;
        vmd.www_script_versionRequired = true;
      }
      if(!validate) return
      var putFunction = function() {
        $rootScope.hasLoaded = false; 
        putDataService.update({
          param1:'options',
          param2:'script-version'
        },{
          'www_script_version': vmd.config.www_script_version
        }).$promise.then(function(putdata){
          $rootScope.hasLoaded = true;
          alertService('success','Success ', putdata.message, 2000);
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status == 401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  putFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
              // report progress
            });
          }else if(error.status ==502) {
              serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;  
        });
      }
      putFunction();
    }
    // vmd.blackThemeUpdate = function() {
    //   if(vmd.blackTheme && (!date_start || !date_end)) {
    //     alertService('danger','Opps! ', 'Please enter a date range.');
    //     return
    //   }
    //   putDataService.update({
    //     param1:'options',
    //     param2:'black-theme'
    //   },{
    //     'black_theme':(vmd.blackTheme)? {
    //       'date_start':date_start,
    //       'date_end':date_end,
    //     } : null
    //   }).$promise.then(function(putdata){
    //     $rootScope.hasLoaded = true;
    //     alertService('success','Success ', putdata.message, 2000);
    //   }, function(error){
    //     if(!window.navigator.onLine) {
    //       offlineError()
    //       $rootScope.hasLoaded = true;
    //       alertService('danger','Opps! ', 'Please check your internet connection and try again.');
    //       return
    //     }
    //     if(error.status ==401) {
    //       var promise = refreshtokenService.getAccessToken();
    //       promise.then(
    //         function(answer) {
    //           if(answer==200) {
    //             vmd.blackThemeUpdate();
    //           }
    //         },
    //         function(error) {
    //         },
    //         function(progress) {
    //           // report progress
    //         });
    //     } else if(error.status ==502) {
    //       serverError()
    //     } else {
    //       alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
    //     }
    //     $rootScope.hasLoaded = true;      
    //   })
    // }
    // vmd.blackThemeChange = function(value) {
    //   if(!value) {
    //     date_start = null;
    //     date_end = null;
    //     $scope.$broadcast('clear-daterange',true);
    //   }
    // }
    // vmd.changeDate = function(value) {
    //   if(value) {
    //     if(value.startDate && value.endDate) {
    //       date_start = Math.floor(value.startDate.valueOf() / 1000);
    //       date_end = Math.floor(value.endDate.valueOf() / 1000);
    //     } else {
    //       date_start = null;
    //       date_end = null;
    //     }
    //   } else {
    //       date_start = null;
    //       date_end = null;
    //   }
    // }
    // Highcharts.setOptions({
    //   global: {
    //       useUTC: false
    //   },
    //   colors: ['#337ab7'],
    //   style: {
    //       fontFamily: "Open Sans"
    //   }
    // });
    var putFunction = function() {
      $rootScope.hasLoaded = false; 
      putDataService.update({
        param1:'options',
        param2:'3rdparty-scripts'
      },{
        'scripts':(vmd.thirdparty)? 1:0,
      }).$promise.then(function(putdata){
        $rootScope.hasLoaded = true;
        alertService('success','Success ', putdata.message, 2000);
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
          return
        }
        if(error.status == 401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {   
                putFunction();
              }
            },
            function(error) {
              // report something
            },
            function(progress) {
            // report progress
          });
        }else if(error.status ==502) {
            serverError()
        } else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
        $rootScope.hasLoaded = true;  
      });
    }
    vmd.thirdpartyChange =function() {
      putFunction();
    }
    var getThirdPartyFunction = function() {
      getDataService.get({param1:'options', param2:'3rdparty-scripts'}).$promise.then(function(data){
        if(data && (data.scripts === '0' || data.scripts === 0)) {
          vmd.thirdparty = false
        } else {
          vmd.thirdparty = true
        }
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                getThirdPartyFunction();
              }
            },
            function(error) {
            },
            function(progress) {
              // report progress
          });
        } else if(error.status ==502) {
          serverError()
        } else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
      }); 
    }
    getThirdPartyFunction()
    // var getDataFunction = function() {
    //   getDataService.get({param1:'posts', param2: 'refresh', param3:'latest'}).$promise.then(function(data){
    //     $rootScope.hasLoaded = true;
    //     alertService('success','Success ', data.message, 2000);
    //   }, function(error){
    //     if(!window.navigator.onLine) {
    //       offlineError()
    //       $rootScope.hasLoaded = true;
    //       alertService('danger','Opps! ', 'Please check your internet connection and try again.');
    //       return
    //     }
    //     if(error.status ==401) {
    //       var promise = refreshtokenService.getAccessToken();
    //       promise.then(
    //         function(answer) {
    //           if(answer==200) {
    //             getDataFunction();
    //           }
    //         },
    //         function(error) {
    //         },
    //         function(progress) {
    //           // report progress
    //       });
    //     } else if(error.status ==502) {
    //       serverError()
    //     } else {
    //       alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
    //     }
    //     $rootScope.hasLoaded = true;
    // }); 
    // }
    // vmd.refreshLatestPost = function() {
    //   $rootScope.hasLoaded = false;
    //   getDataFunction();
    // }
    // vmd.refreshMobile = function() {
    //     $rootScope.hasLoaded = false;
    //     getMobileFunction();
    // }
    // var getMobileFunction = function() {
    //     getDataService.get({param1:'posts', param2: 'refresh', param3:'mobileHome'}).$promise.then(function(data){
    //         $rootScope.hasLoaded = true;
    //         alertService('success','Success ', data.message, 2000);
    //       }, function(error){
    //         if(!window.navigator.onLine) {
    //           offlineError()
    //           $rootScope.hasLoaded = true;
    //           alertService('danger','Opps! ', 'Please check your internet connection and try again.');
    //           return
    //         }
    //         if(error.status ==401) {
    //           var promise = refreshtokenService.getAccessToken();
    //           promise.then(
    //             function(answer) {
    //               if(answer==200) {
    //                 getDataFunction();
    //               }
    //             },
    //             function(error) {
    //             },
    //             function(progress) {
    //               // report progress
    //           });
    //         } else if(error.status ==502) {
    //           serverError()
    //         } else {
    //           alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
    //         }
    //         $rootScope.hasLoaded = true;
    //     }); 
    // }
    // function getRealTimeAnalytics (eleId,t,redraw) {
    //   getDataService.get({param1:'analytics', param2: 'realtime_v2', t:t, isp:eleId}).$promise.then(function(data){
    //     if(data && data.analytics && data.analytics[eleId] && data.analytics[eleId].length>0) {
    //       var chartPointArray = [];
    //       for(var i=0; i<data.analytics[eleId].length;i++) {
    //         var pointItem = [data.analytics[eleId][i].date,data.analytics[eleId][i].count]
    //         chartPointArray.push(pointItem);	  
    //       }
    //       if(redraw) {
    //         if (chartPointArray.length == 0) return
    //         $scope.$broadcast('hc-chart-'+eleId, chartPointArray);
    //       } else {
    //         vmd.chartOptions[eleId] = {
    //           chart: {
    //             type: 'spline',
    //             animation: Highcharts.svg, // don't animate in old IE
    //             margin: [10, 0, 0, 0],
    //             spacing: [0, 0 , 0 , 0],
    //             events: {
    //                   load: function () {
    //                     if(window.socketAnalytics) {
    //                       window.socketAnalytics.on(eleId, function(wsData){
    //                         var x = wsData.date // current time
    //                         if(eleId =='total') {
    //                           var y = wsData.count
    //                         } else {
    //                           var y = wsData.isp[eleId];
    //                         }
    //                         $scope.$broadcast('hc-chart-'+eleId, [x,y], 'socket');
    //                       })
    //                     }
    //                   }
    //               }
    //           },
    //           title: {
    //               enabled:false
    //           },
    //           xAxis: {
    //               type:'datetime',
    //               ordinal: false,
    //               labels: {
    //                 style: {
    //                     color: '#000',
    //                     fontSize:'12px',
    //                     fontWeight: 600
    //                 }
    //             }
    //           },
    //           yAxis: {
    //               title: {
    //                   text: 'Number of users'
    //               },
    //               min : 0,
    //               labels: {
    //                 style: {
    //                     color: '#000',
    //                     fontSize:'14px',
    //                     fontWeight: 600
    //                 }
    //               }
    //           },
    //           navigator: {
    //             xAxis: {
    //               labels: {
    //                 style: {
    //                     color: '#555',
    //                 }
    //               }
    //             }
    //           },
    //           legend: {
    //               enabled: false
    //           },
    //           series: [{
    //             data: chartPointArray,
    //             name: 'Users',
    //             type: 'area',
    //             tooltip: {
    //               valueDecimals: 0
    //             }
    //           }],
    //           tooltip: {
    //             dateTimeLabelFormats: {
    //               millisecond: "%b %e, %H:%M:%S"
    //             },
    //             backgroundColor: '#ffff',
    //             style: {
    //               fontSize: '14px' 
    //             }
    //           },
    //           plotOptions: {
    //             area: {
    //               fillColor: {
    //                 linearGradient: {
    //                     x1: 0,
    //                     y1: 0,
    //                     x2: 0,
    //                     y2: 1
    //                 },
    //                 stops: [
    //                   [0, Highcharts.getOptions().colors[0]],
    //                   [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
    //                 ]
    //               },
    //               marker: {
    //                   radius: 2
    //               },
    //               lineWidth: 1,
    //               states: {
    //                   hover: {
    //                       lineWidth: 1
    //                   }
    //               },
    //               threshold: null
    //             }
    //           },
    //           rangeSelector: {
    //             enabled:false
    //           }
    //           // rangeSelector: {
    //           //     verticalAlign: 'bottom',
    //           //     x: 0,
    //           //     y: 0,
    //           //     buttons: [
    //           //     // {
    //           //     //     count: 30,
    //           //     //     type: 'minute',
    //           //     //     text: '30M'
    //           //     // },
    //           //     // {
    //           //     //     count: 60,
    //           //     //     type: 'minute',
    //           //     //     text: '60M'
    //           //     // }, 
    //           //     {
    //           //         type: 'all',
    //           //         text: 'All'
    //           //     }],
    //           //     inputEnabled: false,
    //           //     selected: 0
    //           // },
    //         }
    //         vmd.loadAnalytics[eleId] = true;
    //       }
          
    //     }
        
    //   }, function(error){
    //     if(!window.navigator.onLine) {
    //       offlineError()
    //       alertService('danger','Opps! ', 'Please check your internet connection and try again.');
    //       return
    //     }
    //     if(error.status ==401) {
    //       var promise = refreshtokenService.getAccessToken();
    //       promise.then(
    //         function(answer) {
    //           if(answer==200) {
    //             getRealTimeAnalytics();
    //           }
    //         },
    //         function(error) {
    //         },
    //         function(progress) {
    //           // report progress
    //       });
    //     } else if(error.status ==502) {
    //       serverError()
    //     } else {
    //       alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
    //     }
    //   }); 
    // }
    // setTimeout(function(){
    //   var lazyChart = [].slice.call(document.querySelectorAll(".isp-chart-lazy"));
    //   if(lazyChart.length==0) return;
    //   intersectionObserverGlobal(lazyChart,loadChart, vmd.config.rootMarginLazy);
    // },100)
    // vmd.redrawChart = function(event,zoom,eleId) {
    //   activeClass.active(event);
    //   getRealTimeAnalytics(eleId,zoom,'redraw')
      
    // }
    // function loadChart(ele) {
    //   var eleId = ele.getAttribute('id');
    //   getRealTimeAnalytics(eleId,vmd.config.isp.zoom[0]) 
      
    // }
    $scope.$on('$destroy', function() {
      // if(window.socketAnalytics) {
      //   window.socketAnalytics.eventListenerCb = {
      //     'global': window.socketAnalytics.eventListenerCb.global
      //   }
      // }
    });
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/dashboardModule/js/dashboardController.js
// module id = 500
// module chunks = 0